import Renderer, { RenderOptions } from '../Renderer';
import Comment from '../../nodes/Comment';

export default function(_node: Comment, _renderer: Renderer, _options: RenderOptions) {
	// TODO preserve comments

	// if (options.preserveComments) {
	// 	renderer.append(`<!--${node.data}-->`);
	// }
}
